import styled from "styled-components";
import { Colors } from "../../../../shared/colors/colors";

export const DadosFinanceirosContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  padding: 0;
  border-radius: 0;
  border: 0;
`;

export const TextAreaObservacao = styled.textarea`
  resize: vertical;
  min-height: 118px;
  width: 100%;
  border: 1px solid ${Colors.borderInput};
  border-radius: 8px;
  padding: 12px;
  font-family: inherit;
  font-size: 16px;
  outline: none;
  &:disabled {
    background-color: #f5f6f7;
    cursor: not-allowed;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  width: 90vw;
`;
